import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
declare var $: any;
import { newslist, months, years, quaters } from './../../shared/constants';
import { CanonicalService } from '../../shared/canonical.service';

@Component({
  selector: 'app-media',
  templateUrl: './media.component.html',
  styleUrls: ['./media.component.css']
})
export class MediaComponent implements OnInit {

  heading = "Media";
  subheading = "Protectt.ai in the news";

  newslist = newslist;
  filterdNews: any = [];
  quaters= quaters;
  months = months;
  years = years;
  quateritem: string = '';
  currqtr: string = '';
  yearitem: string = '';
  innerWidth:number = window.innerWidth;

  constructor(private titleService: Title, private metaTagService: Meta, private metaTagService1: Meta, private canonicalService: CanonicalService) { 
    this.canonicalService.setCanonicalURL("https://www.protectt.ai/media");
  }

  ngOnInit(): void {

    this.titleService.setTitle('News | Media | PR | Protectt.ai');
    this.metaTagService1.updateTag({ name: 'title', content: 'News | Media | PR | Protectt.ai'});
    this.metaTagService.updateTag({ name: 'description', content: 'Be a Protecttor by joining our diverse group of innovators working together to solve complex Mobile Cyber Security challenges.'});

    const d = new Date()
    let qtr=d.getMonth()+1;
    if(qtr <= 4){
      this.currqtr = 'q1';
    }else if(qtr > 4 && qtr <= 8){
      this.currqtr = 'q2';
    }else if(qtr > 8 && qtr <= 12){
      this.currqtr = 'q3';
    }
    let yearinfo:any = d.getFullYear();
    this.yearitem = yearinfo;
    // this.filterNews(this.currqtr, yearinfo);
  }

  finddata() {
    
  }

  showMediaPopup() {
    $('#mediaimagepopup').modal('show');
  }

  ngOnDestroy(): void {
    $('#mediaimagepopup').modal('hide');
  }

  // filterNews(quater: any, year: any) {
  //   this.filterdNews = this.newslist;
  //   if(quater == "q1"){
  //     this.filterdNews = this.newslist.filter(p => ((p.quater_id == 'q1') && (p.year == year)));
  //   }else if(quater == "q2"){
  //     this.filterdNews = this.newslist.filter(p => ((p.quater_id == 'q2') && (p.year == year)));
  //   }else if(quater == "q3"){
  //     this.filterdNews = this.newslist.filter(p => ((p.quater_id == 'q3') && (p.year == year)));
  //   }
  // }
  onResize(event:any){
    this.innerWidth = event.target.innerWidth;
  }
}
